import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import ProjectVersionTree from "../domain/project/projectVersionTreeDomain";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import StyledSelect from "../../core/components/fields/styledSelect";
import {reaction} from "mobx";


@observer
class ProjectVersionTreeForm extends React.Component<FormProps<ProjectVersionTree, ProjectVersionTree>, any> {


  constructor(props: FormProps<ProjectVersionTree, ProjectVersionTree>, context: any) {
    super(props, context);

    reaction(
      () => props.dataObject.indigenous,
      indigenous => {
        if (indigenous) {
          const form = props.dataObject.getForm(ProjectVersionTreeFormDefinition.formName);
          props.dataObject.newlyPlanted = false;
          props.dataObject.cutDown = false;
          form.updateFieldsPropValue(props.dataObject, 'newlyPlanted', 'cutDown');
        }
      }
    );

    reaction(
      () => props.dataObject.newlyPlanted,
      newlyPlanted => {
        if (newlyPlanted) {
          const form = props.dataObject.getForm(ProjectVersionTreeFormDefinition.formName);
          props.dataObject.indigenous = false;
          props.dataObject.cutDown = false;
          form.updateFieldsPropValue(props.dataObject, 'indigenous', 'cutDown');
        }
      }
    );

    reaction(
      () => props.dataObject.cutDown,
      cutDown => {
        if (cutDown) {
          const form = props.dataObject.getForm(ProjectVersionTreeFormDefinition.formName);
          props.dataObject.indigenous = false;
          props.dataObject.newlyPlanted = false;
          form.updateFieldsPropValue(props.dataObject, 'indigenous', 'newlyPlanted');
        }
      }
    );

  }


  render(): JSX.Element | false | null {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionTreeFormDefinition.formName);
    let {
      name, trunkCircumference, crownDiameter, distanceFromFacade, facadeOrientation,
      indigenous, newlyPlanted, cutDown
    } = fields;

    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-4 col-sm-4'>
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdTextField {...trunkCircumference.props}/>
            <Validate field={trunkCircumference} value={trunkCircumference.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdTextField {...crownDiameter.props}/>
            <Validate field={crownDiameter} value={crownDiameter.props.value} />
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...distanceFromFacade.props}/>
            <Validate field={distanceFromFacade} value={distanceFromFacade.props.value} />
          </div>
          <div className='fx col-xs-6 col-sm-6'>
            <StyledSelect {...facadeOrientation.props} />
            <Validate field={facadeOrientation} value={facadeOrientation.props.value}/>
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...indigenous.props}  />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...newlyPlanted.props} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...cutDown.props} />
          </div>
        </div>
      </div>
    );
  }


}

export const ProjectVersionTreeFormDefinition: DefinitionType = {
  formName: 'ProjectVersionTreeForm',
  fields: [
    {name : 'name', validators : ['IsRequired']},
    {name : 'trunkCircumference', validators: ['IsRequired', 'IsNumber']},
    {name : 'crownDiameter', validators: ['IsRequired', 'IsNumber']},
    {name : 'distanceFromFacade', validators: ['IsRequired', 'IsNumber']},
    {name : 'facadeOrientation', validators: ['IsRequired']},
    {name : 'indigenous'},
    {name : 'newlyPlanted'},
    {name : 'cutDown'}
  ]
};

export default createForm(ProjectVersionTreeFormDefinition, null)(ProjectVersionTreeForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionTreeForm.tsx